import { actions, selectors } from '../../../../state';
import { IS_TOUCH_DEVICE } from '../../../../constants';
import template from './moving-center-offer-card.html';
import './moving-center-offer-card.global.css';

class MovingCenterOfferCardController {
  constructor(updStore, MovingCenterActions) {
    'ngInject';
    Object.assign(this, {
      updStore,
      MovingCenterActions,
    });
  }

  $onInit() {
    const state = this.updStore.getState();
    this.submitted = selectors.movingCenter.hasRequestedOffer(
      this.moveId,
      this.company.id,
      state
    );
  }

  get promotion() {
    return this.company.config.promotion;
  }

  get descriptionTitle() {
    // Always show "About:" to preface description unless a price is set.
    return (this.pricing ? `What's included` : 'About') + ':';
  }

  get description() {
    return this.company.config.description;
  }

  get pricing() {
    return this.company.config.pricing;
  }

  get analyticsProperties() {
    return { 'Company Code': this.company.name };
  }

  get tooltip() {
    return !IS_TOUCH_DEVICE
      ? `Click here and we'll send your move details to ${
          this.company.name
        }. They'll reach out ASAP.`
      : undefined;
  }

  requestOffer() {
    const { dispatch } = this.updStore;
    this.submitting = true;

    const state = this.updStore.getState();
    const data = {
      first_name: selectors.movingCenter.firstName(this.moveId, state),
      last_name: selectors.movingCenter.lastName(this.moveId, state),
      email: selectors.movingCenter.email(this.moveId, state),
      move_type: selectors.movingCenter.matchMoveType(
        this.moveId,
        this.company.id,
        state
      ),
      moving_company: this.company.id,
      moving_center_preference: selectors.movingCenter.id(this.moveId, state),
    };

    dispatch(this.MovingCenterActions.request(data))
      .then(
        () => (this.submitted = true),
        () =>
          dispatch(
            actions.message.error(
              'We encountered an error sending the request.'
            )
          )
      )
      .finally(() => (this.submitting = false));
  }
}

export const MovingCenterOfferCardComponent = {
  template,
  controller: MovingCenterOfferCardController,
  bindings: {
    company: '<',
    moveId: '<',
  },
};
